export const statusUser = [
    {name: 'Chưa kích hoạt', color: '#77b6d1', id: 0},
    {name: 'Dùng thử', color: '#1356c1', id: 1},
    {name: 'Đang sử dụng', color: '#ff8038', id: 2},
    {name: 'Hết hạn sử dụng', color: '#cc4d4d', id: 3},
    {name: 'Hết hạn dùng thử', color: '#6b6b6b', id: 4},
    {name: 'Khác', color: '#8950fc', id: 99}
];